import { render, staticRenderFns } from "./TextNoteReference.vue?vue&type=template&id=52cfae25&"
import script from "./TextNoteReference.vue?vue&type=script&lang=js&"
export * from "./TextNoteReference.vue?vue&type=script&lang=js&"
import style0 from "./TextNoteReference.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports